/**
 * Created by sivanh on 17/06/2018.
 */
define(function (require) {
    "use strict";
    var LE = require("app");
    var SingleSelect = require("ui/singleselect-new/Singleselect");
    var ScheduleUtilities = require("utils/ScheduleUtilities");

    var template = require("manager-templates/schedule/scheduleShiftItemView.tmpl");

    var ScheduleEventItemView = {};
    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        ScheduleEventItemView = Marionette.CompositeView.extend({
            template: template,
            tagName:"li",
            className:"shift-row-container",
            ui: {
                startTimeSingleSelect: ".start-time-container .single-select-container",
                endTimeSingleSelect: ".end-time-container .single-select-container",
                deleteButton: ".shift-delete-button"
            },
            uiComponents: {
                startTimeSingleSelect: {
                    type: SingleSelect,
                    options: {
                        container: "view.ui.startTimeSingleSelect",
                        permutation: SingleSelect.PERMUTATION.P,
                        theme: SingleSelect.THEME.DEFAULT,
                        errorPosition: SingleSelect.ERROR_POSITION.RIGHT,
                        useCreateNewItemOption: false,
                        list: {
                            itemHeight: 30,
                            itemsComparator: "id"
                        },
                        inputField: {
                            placeholder: "hh:mm"
                        },
                        items: "view._getTimesSingleSelectOptions",
                        selectedItem: "view._getSelectedStartTimeItem"
                    },
                    events: {
                        "change": "_onStartTimeChange",
                        "input:change": "_onStartTimeChange",
                        "blur": "_validateTimeInput"
                    }
                },
                endTimeSingleSelect: {
                    type: SingleSelect,
                    options: {
                        container: "view.ui.endTimeSingleSelect",
                        permutation: SingleSelect.PERMUTATION.P,
                        theme: SingleSelect.THEME.DEFAULT,
                        errorPosition: SingleSelect.ERROR_POSITION.RIGHT,
                        useCreateNewItemOption: false,
                        list: {
                            itemHeight: 30,
                            itemsComparator: "id"
                        },
                        inputField: {
                            placeholder: "hh:mm"
                        },
                        items: "view._getTimesSingleSelectOptions",
                        selectedItem: "view._getSelectedEndTimeItem"
                    },
                    events: {
                        "change": "_onEndTimeChange",
                        "input:change": "_onEndTimeChange",
                        "blur": "_validateTimeInput"
                    }
                }
            },
            events: {
                "click .shift-delete-button": "_onDeleteButtonClicked",
            },

            initialize: function(options) {
                this._initialize(options);
            },

            onValidatedInvalid: function (model, errors) {
                return this._onValidatedInvalid(model, errors);
            },

            _initialize: function(options) {
                this.channel = options.channel;
            },

            _getTimesSingleSelectOptions: function () {
                return ScheduleUtilities.getShiftTimesOptionsForSingleSelect();
            },

            _getSelectedStartTimeItem: function () {
                var timeKey = this.model.getStartTime();
                return timeKey;
            },

            _getSelectedEndTimeItem: function () {
                var timeKey= this.model.getEndTime();
                return timeKey;
            },

            _onStartTimeChange: function(componentId, eventName, value) {
                var id = _.has(value, "item") ? value.item.id : "";
                var timeObj = this.uiComponents.startTimeSingleSelect.getSelectedItem();

                if (!_.isEmpty(timeObj)) {
                    id = timeObj.id;
                }

                this.channel.trigger("ScheduleShiftItem:change:hours:startTime", this.model, id);

            },

            _onEndTimeChange: function(componentId, eventName, value) {
                var id = _.has(value, "item") ? value.item.id : "";
                var timeObj = this.uiComponents.endTimeSingleSelect.getSelectedItem();

                if (!_.isEmpty(timeObj)) {
                    id = timeObj.id;
                }

                this.channel.trigger("ScheduleShiftItem:change:hours:endTime", this.model, id);
            },

            _validateTimeInput : function (componentId, eventName) {
                var timeVal = this.uiComponents[componentId].getInputValue();
                var timeObj = this.uiComponents[componentId].getSelectedItem();
                if (!_.isEmpty(timeVal)) {  // only if not empty value
                    if (_.isEmpty(timeObj)) {
                        this.uiComponents[componentId].setError(true, LE.translator.translate("LEManager.scheduleEditView.shift.time.unknownTime"));
                        return false;
                    }
                    else {
                        this.uiComponents[componentId].setInputValue(timeObj.value);
                    }
                }
                return true;
            },

            _onDeleteButtonClicked: function (ev) {
                this.trigger("remove:shift:clicked", this.model);
            },

            _onValidatedInvalid: function(model, errors) {
                this._hideErrors();

                if (_.has(errors, this.model.KEYS.START_TIME)) {
                    this.uiComponents.startTimeSingleSelect.setError(true, errors[this.model.KEYS.START_TIME]);
                }
                if (_.has(errors, this.model.KEYS.END_TIME)) {
                    this.uiComponents.endTimeSingleSelect.setError(true, errors[this.model.KEYS.END_TIME]);
                }
            },

            _hideErrors: function() {
                this.uiComponents.startTimeSingleSelect.setError(false);
                this.uiComponents.endTimeSingleSelect.setError(false);
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return ScheduleEventItemView;
});

